import styled from "styled-components";

export const DialogBackground = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: center;
  z-index: 99998;
`;

export const Dialog = styled.div`
  position: fixed;
  background-color: white;
  z-index: 999999;
  max-width: 50vw;
  max-height: 80vh;
  overflow-y: scroll;

  @media screen and (max-width: 992px) {
    max-width: 80vw;
  }
`;

export const QuitButton = styled.div`
  height: 100%;
  width: 20px;
  text-align: center;
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
  float: right;
`;
